/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */;(function initWOMCardRatings() {
  var API_URL = "https://api.thewordofmouth.in/api/overall_company/sotrue";
  var REVIEWS_BASE = "https://api.thewordofmouth.in/api/reviews/sotrue/";
  var CACHE_KEY = "wom_overall_company_sotrue_v1";
  var CACHE_TTL_MS = 10 * 60 * 1000;
  var HANDLE_CACHE_KEY = "wom_card_handle_stats_v1";
  var lastFreshData = null;

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || !parsed.data) return null;
      if (Date.now() - parsed.t > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function readHandleCache() {
    try {
      var raw = sessionStorage.getItem(HANDLE_CACHE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeHandleCache(map) {
    try {
      sessionStorage.setItem(HANDLE_CACHE_KEY, JSON.stringify(map || {}));
    } catch (e) {}
  }

  function formatCount(n) {
    var num = Number(n) || 0;
    if (num >= 100000) return Math.round(num / 1000) + "K";
    if (num >= 10000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    return String(num);
  }

  function render(el, payload) {
    if (!el) return;
    if (!payload || !payload.total_reviews || !payload.overall_rating) {
      el.innerHTML = "";
      return;
    }
    var rating = Number(payload.overall_rating) || 0;
    var total = Number(payload.total_reviews) || 0;
    if (rating <= 0 || total <= 0) {
      el.innerHTML = "";
      return;
    }

    el.innerHTML =
      '<div class="rating">' +
      '  <div class="average-rating">' +
      '    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5.05514 0.726234C5.36592 -0.170471 6.63408 -0.17047 6.94486 0.726235L7.56303 2.50984C7.70255 2.91242 8.08182 3.18237 8.50789 3.18237H10.364C11.3482 3.18237 11.7404 4.45477 10.9269 5.00886L9.5387 5.95442C9.1654 6.20868 9.00888 6.68162 9.15679 7.10838L9.71281 8.71268C10.0282 9.62276 9.00106 10.4089 8.205 9.86664L6.56295 8.74819C6.2233 8.51684 5.7767 8.51684 5.43705 8.74819L3.795 9.86664C2.99894 10.4089 1.97177 9.62276 2.28719 8.71268L2.84321 7.10838C2.99112 6.68161 2.8346 6.20868 2.4613 5.95442L1.07309 5.00886C0.259601 4.45477 0.651769 3.18237 1.63604 3.18237H3.49211C3.91818 3.18237 4.29745 2.91241 4.43697 2.50984L5.05514 0.726234Z" fill="white"></path></svg>' +
      "    " + rating.toFixed(2) +
      "  </div>" +
      '  <div class="review-count">' +
      '    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.82869 0.608018C9.20971 0.262926 9.79029 0.262926 10.1713 0.608018L10.8807 1.25057C11.1392 1.48465 11.5009 1.5672 11.8353 1.46844L12.7533 1.19733C13.2463 1.05173 13.7694 1.30364 13.9629 1.77987L14.3233 2.6666C14.4546 2.98963 14.7446 3.22095 15.0888 3.27706L16.0335 3.43109C16.5408 3.51382 16.9028 3.96774 16.8706 4.48079L16.8105 5.43607C16.7887 5.78407 16.9496 6.11833 17.2354 6.31821L18.0197 6.86687C18.4409 7.16154 18.5701 7.72757 18.3184 8.17582L17.8498 9.01045C17.6791 9.3145 17.6791 9.6855 17.8498 9.98955L18.3184 10.8242C18.5701 11.2724 18.4409 11.8385 18.0197 12.1331L17.2354 12.6818C16.9496 12.8817 16.7887 13.2159 16.8105 13.5639L16.8706 14.5192C16.9028 15.0323 16.5408 15.4862 16.0335 15.5689L15.0888 15.7229C14.7446 15.7791 14.4546 16.0104 14.3233 16.3334L13.9629 17.2201C13.7694 17.6964 13.2463 17.9483 12.7533 17.8027L11.8353 17.5316C11.5009 17.4328 11.1392 17.5154 10.8807 17.7494L10.1713 18.392C9.79029 18.7371 9.20971 18.7371 8.82869 18.392L8.11926 17.7494C7.86082 17.5154 7.49912 17.4328 7.16471 17.5316L6.24674 17.8027C5.75373 17.9483 5.23064 17.6964 5.03709 17.2201L4.6767 16.3334C4.54542 16.0104 4.25536 15.7791 3.91122 15.7229L2.96652 15.5689C2.45916 15.4862 2.09717 15.0323 2.12942 14.5192L2.18946 13.5639C2.21133 13.2159 2.05036 12.8817 1.76465 12.6818L0.980338 12.1331C0.559115 11.8385 0.429922 11.2724 0.681579 10.8242L1.15016 9.98955C1.32086 9.6855 1.32086 9.3145 1.15016 9.01045L0.681579 8.17582C0.429922 7.72757 0.559115 7.16154 0.980338 6.86687L1.76465 6.31821C2.05036 6.11833 2.21133 5.78407 2.18946 5.43607L2.12942 4.48079C2.09717 3.96774 2.45916 3.51382 2.96652 3.43109L3.91122 3.27706C4.25536 3.22095 4.54542 2.98963 4.6767 2.6666L5.03709 1.77987C5.23064 1.30364 5.75373 1.05173 6.24674 1.19733L7.16471 1.46844C7.49912 1.5672 7.86082 1.48465 8.11926 1.25057L8.82869 0.608018Z" fill="#51ABEB"></path><path d="M6 10.742L8.56511 12.4226L14 8" stroke="white" stroke-width="2.65356" stroke-linecap="square"></path></svg>' +
      "    " + formatCount(total) + " Verified Reviews" +
      "  </div>" +
      "</div>";
  }

  function applyAll(data) {
    var nodes = document.querySelectorAll("[data-wom-card-rating][data-product-handle]");
    if (!nodes || !nodes.length) return;
    var handleCache = readHandleCache();

    nodes.forEach(function (el) {
      var handle = el.getAttribute("data-product-handle");
      if (!handle) return;
      var payload = (data && data[handle]) || handleCache[handle];
      render(el, payload);
    });

    var missing = [];
    nodes.forEach(function (el) {
      var handle = el.getAttribute("data-product-handle");
      if (!handle) return;
      if ((data && data[handle]) || handleCache[handle]) return;
      missing.push(handle);
    });
    if (missing.length) {
      missing = Array.from(new Set(missing));
      fetchMissingHandles(missing, handleCache);
    }
  }

  function fetchData() {
    return fetch(API_URL, { credentials: "omit" })
      .then(function (r) { return r.json(); })
      .then(function (json) { writeCache(json); return json; })
      .catch(function () { return null; });
  }

  function fetchHandleStats(handle) {
    var url = REVIEWS_BASE + encodeURIComponent(handle) + "?offset=0&limit=1";
    return fetch(url, { credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || typeof json !== "object") return null;
        var overall = Number(json.overall_rating || (json.stats && json.stats.overall_rating) || 0);
        var total = Number(json.total_reviews || (json.stats && json.stats.total_reviews) || 0);
        if (!overall || !total) return null;
        return { overall_rating: overall, total_reviews: total };
      })
      .catch(function () { return null; });
  }

  function fetchMissingHandles(handles, handleCache) {
    var queue = handles.slice(0);
    var concurrency = 4;
    var inFlight = 0;

    function pump() {
      while (inFlight < concurrency && queue.length) {
        (function (h) {
          inFlight++;
          fetchHandleStats(h).then(function (stats) {
            if (stats) {
              handleCache[h] = stats;
              writeHandleCache(handleCache);
              var els = document.querySelectorAll('[data-wom-card-rating][data-product-handle="' + h.replace(/"/g, '\\"') + '"]');
              els.forEach(function (el) { render(el, stats); });
            }
          }).finally(function () {
            inFlight--;
            if (queue.length) pump();
          });
        })(queue.shift());
      }
    }

    pump();
  }

  function init() {
    var cached = readCache();
    if (cached) applyAll(cached);
    fetchData().then(function (fresh) {
      if (fresh) {
        lastFreshData = fresh;
        applyAll(fresh);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    var cached = readCache();
    if (cached) applyAll(cached);
  });
  document.addEventListener("cart:refresh", function () {
    var cached = readCache();
    if (cached) applyAll(cached);
  });

  try {
    var womApplyTimer = null;
    var womObserver = new MutationObserver(function (mutations) {
      var shouldApply = false;
      for (var i = 0; i < mutations.length && !shouldApply; i++) {
        var m = mutations[i];
        if (!m || !m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches("[data-wom-card-rating][data-product-handle]")) ||
            (node.querySelector && node.querySelector("[data-wom-card-rating][data-product-handle]"))
          ) {
            shouldApply = true;
            break;
          }
        }
      }
      if (!shouldApply) return;

      clearTimeout(womApplyTimer);
      womApplyTimer = setTimeout(function () {
        var cached = readCache();
        if (cached) {
          applyAll(cached);
          return;
        }
        if (lastFreshData) {
          applyAll(lastFreshData);
          return;
        }
        fetchData().then(function (fresh) {
          if (fresh) {
            lastFreshData = fresh;
            applyAll(fresh);
          }
        });
      }, 50);
    });

    womObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
  } catch (e) {}
})();